import { DistributionReportStat } from '../../../Common/TargetingShared/model/statisticsReport/distribution-report-stat-api.model';

export class RecipientNegativeoutcomeStatsModel {
    [DistributionReportStat.UNSUBSCRIBED]: number;
    [DistributionReportStat.PREVIOUS_UNSUB]: number;
    [DistributionReportStat.HARD_BOUNCED]: number;
    [DistributionReportStat.PREVIOUS_HARD_BOUNCED]: number;
    [DistributionReportStat.SPAM_REPORT]: number;

    constructor(
        unsubscribed = 0,
        preUnsubscribed = 0,
        hardBounce = 0,
        preHardBounced = 0,
        spamReport = 0){
        this[DistributionReportStat.UNSUBSCRIBED] = unsubscribed;
        this[DistributionReportStat.PREVIOUS_UNSUB] = preUnsubscribed;
        this[DistributionReportStat.HARD_BOUNCED] = hardBounce;
        this[DistributionReportStat.PREVIOUS_HARD_BOUNCED] = preHardBounced;
        this[DistributionReportStat.SPAM_REPORT] = spamReport;
    }
}
